export const dramas = [
  {
    id: 'chongsheng-haomen',
    title: '重生之我在豪门当团宠',
    subtitle: '重回十八岁，这一次账本我来翻',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20wealthy%20modern%20family%20mansion%20interior%20at%20dusk%2C%20elegant%20young%20woman%20in%20a%20refined%20dress%20standing%20by%20a%20tall%20window%2C%20warm%20golden%20lighting%2C%20dramatic%20soft%20shadows%2C%20luxurious%20crimson%20and%20amber%20tones%2C%20editorial%20streaming%20drama%20key%20art&width=600&height=800&seq=duanju-cover-01&orientation=portrait',
    category: '都市逆袭',
    tags: ['重生', '豪门', '打脸'],
    totalEpisodes: 80,
    updatedEpisodes: 52,
    status: '更新中',
    schedule: '每周一至周五 12:00 更新2集',
    scheduleDays: [1, 2, 3, 4, 5],
    rating: 9.2,
    heat: 1286000,
    synopsis:
      '被继母与养妹联手算计、在颁奖礼上身败名裂的林晚，意外重回十八岁那年的家宴。这一次她带着全部记忆回到豪门中心：先在继母的账本里埋下第一个破绽，再借祖母寿宴重夺长辈信任，一步步拿回属于母亲的那份股权。全季围绕「揭开假千金身世、夺回集团股权、修复与少年挚友的关系」三条主线推进，从宅斗初见端倪到商场正面交锋，每一集都在为最后那场股东大会铺路。',
    episodes: [
      {
        no: 1,
        title: '重回十八岁那年的家宴',
        summary:
          '颁奖礼上被指抄袭的林晚一觉醒来，发现自己回到了十八岁的家族家宴。她看着还在世的祖母和尚未撕破脸的继母，决定这一次不再退让，先拦下了即将被调换的遗嘱副本。',
        date: '2026-08-03',
      },
      {
        no: 2,
        title: '账本上的第一个破绽',
        summary:
          '林晚借着整理书房的机会拍下继母的私账，发现一笔以「慈善捐款」名义流出的巨额资金。她把线索无意间透露给一向精明的二叔，让家族内部第一次出现裂痕。',
        date: '2026-08-03',
      },
      {
        no: 3,
        title: '祖母寿宴上的反击',
        summary:
          '养妹林夏在寿宴上当众提及林晚的「抄袭旧事」，林晚不慌不忙拿出完整创作手稿与时间戳，反手把当年替人顶罪的真相摆在了长辈面前。',
        date: '2026-08-04',
      },
      {
        no: 4,
        title: '假千金露出马脚',
        summary:
          '一份二十年前的出生记录被送到林晚手里。她和少年挚友顾亦辰核对医院档案，发现林夏的生母与继母早有往来，身世谜团第一次浮出水面。',
        date: '2026-08-05',
      },
      {
        no: 5,
        title: '少年挚友的旧信',
        summary:
          '顾亦辰翻出高中时被退回的信件，两人确认当年那场误会是有人刻意为之。林晚借这封信重新赢得了顾家的支持，也第一次动摇了自己的复仇计划。',
        date: '2026-08-06',
      },
      {
        no: 6,
        title: '股东大会前夜',
        summary:
          '集团股东大会召开在即，继母一方开始转移资产。林晚抢先冻结了关联账户，却在深夜收到一份匿名快递——里面是母亲留下的股权转让书。',
        date: '2026-08-07',
      },
    ],
    nextEpisode: {
      no: 53,
      title: '股权交换',
      date: '2026-09-11',
      preview:
        '股东大会前夜，林晚收到一份匿名快递，里面是母亲留下的股权转让书，而快递单上的寄件人，正是她以为早已去世的人。',
    },
  },
  {
    id: 'changan-shierniang',
    title: '长安十二娘',
    subtitle: '十二位女子的长安浮世绘',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20ancient%20Chinese%20Tang%20dynasty%20palace%20corridor%2C%20ornate%20red%20lanterns%20glowing%2C%20elegant%20noble%20lady%20in%20embroidered%20hanfu%2C%20warm%20gold%20and%20vermillion%20palette%2C%20poetic%20period%20drama%20key%20art%2C%20soft%20mist%2C%20refined%20brush%20texture&width=600&height=800&seq=duanju-cover-02&orientation=portrait',
    category: '古装剧场',
    tags: ['古装', '权谋', '女性群像'],
    totalEpisodes: 60,
    updatedEpisodes: 60,
    status: '已完结',
    schedule: '已完结 · 全集可看',
    scheduleDays: [],
    rating: 9.5,
    heat: 2043000,
    synopsis:
      '上元灯节前夕，长安城里十二位身份各异的女子因为一桩盐铁账目接连被卷入朝堂风波。绣娘、医女、乐师、商妇、女吏各展所长，她们没有兵权也不在朝班，却用一双双眼睛拼出了整张权谋地图。全季以「十二娘」为单位逐集解锁人物，前二十集铺设线索，中段揭开盐铁案背后真正的操盘者，后段以一场没有刀光的上元夜宴收束全局。',
    episodes: [
      {
        no: 1,
        title: '上元灯节的第一盏灯',
        summary:
          '绣娘沈约在灯市的绣屏上发现一处暗纹，纹样里藏着的数字与三日后入库的盐引完全吻合，她随手记下却不知自己已被盯上。',
        date: '2026-06-01',
      },
      {
        no: 2,
        title: '乐师听不出的错音',
        summary:
          '教坊乐师柳七娘在宫宴上听出一个错音，反复推敲后发现是有人借乐曲传递账目暗号，她第一次把消息递给了女吏裴蕴。',
        date: '2026-06-02',
      },
      {
        no: 3,
        title: '药铺里的第七味药',
        summary:
          '医女苏晚照发现自己药铺里多出一味不属于处方的药材，顺着进货单据追查，牵出一家替权贵洗账的商号。',
        date: '2026-06-03',
      },
      {
        no: 4,
        title: '商妇的一碗茶',
        summary:
          '太白酒楼的商妇阿蘅用一碗茶试出了账房先生的破绽，也让十二位女子第一次真正坐到同一张桌前互通消息。',
        date: '2026-06-04',
      },
      {
        no: 5,
        title: '女吏写下的空白奏疏',
        summary:
          '裴蕴在尚书省抄录奏疏时故意留白，用一份「不完整」的公文逼出幕后的调动令，代价是自己被调离长安。',
        date: '2026-06-05',
      },
      {
        no: 6,
        title: '上元夜的十二盏灯',
        summary:
          '上元夜宴开启，十二盏灯依次点亮对应十二位女子的证词。盐铁案落幕，长安城第一次由女子写下结案的那一笔。',
        date: '2026-06-06',
      },
    ],
    nextEpisode: null,
  },
  {
    id: 'xindong-xinhao',
    title: '心动信号：暗恋成真',
    subtitle: '十年后才发现，他一直在原地',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20young%20couple%20sitting%20close%20in%20a%20cozy%20warm%20cafe%2C%20soft%20bokeh%20string%20lights%20behind%20them%2C%20gentle%20pastel%20peach%20and%20cream%20tones%2C%20sweet%20romantic%20mood%2C%20modern%20urban%20romance%20drama%20key%20art%2C%20soft%20natural%20light&width=600&height=800&seq=duanju-cover-03&orientation=portrait',
    category: '甜宠恋爱',
    tags: ['甜宠', '暗恋', '久别重逢'],
    totalEpisodes: 48,
    updatedEpisodes: 34,
    status: '更新中',
    schedule: '每周二、周四、周六 20:00 更新2集',
    scheduleDays: [2, 4, 6],
    rating: 8.8,
    heat: 762000,
    synopsis:
      '电台夜间节目主播夏知遥，在一次直播连线中意外听到了高中同学陆屿的名字。十年前那个总坐在教室最后一排、替她收好每一张试卷的男生，如今成了节目最忠实的深夜听众。故事以「一封未寄出的信」为线索，用电台点歌、旧校服、天台流星一步步揭开双向暗恋的全过程。全季不撒狗血，只把那些被时间藏起来的喜欢，一集一集还给你。',
    episodes: [
      {
        no: 29,
        title: '深夜连线里的熟名字',
        summary:
          '夏知遥在节目里接到一通匿名来电，对方点了一首十年前的校园广播歌单，声音让她握着话筒愣了三秒。',
        date: '2026-09-05',
      },
      {
        no: 30,
        title: '旧校服里的车票',
        summary:
          '整理旧物时，夏知遥在高中校服口袋里摸出一张早已作废的末班车票，背面写着一行她当年没看懂的字。',
        date: '2026-09-05',
      },
      {
        no: 31,
        title: '天台上的流星雨',
        summary:
          '陆屿把她带回高中天台看流星，坦白当年每一张被夹进试卷的便利贴，都是他练习了整晚才敢写下的。',
        date: '2026-09-08',
      },
      {
        no: 32,
        title: '电台点歌的第七封信',
        summary:
          '节目组收到第七封寄给「夏主播」的信，字迹与十年前的便利贴一模一样，夏知遥第一次在直播间里念不下去。',
        date: '2026-09-08',
      },
      {
        no: 33,
        title: '未寄出的那封信',
        summary:
          '陆屿终于把毕业那天没能送出的信交到她手上。信里没有告白，只有一句「如果你也回头看一眼」。',
        date: '2026-09-10',
      },
      {
        no: 34,
        title: '这次换我先开口',
        summary:
          '直播结束后的雨夜，夏知遥第一次主动牵住他的手，说出那句迟到十年的回答，两人并肩走进便利店买了两串关东煮。',
        date: '2026-09-10',
      },
    ],
    nextEpisode: {
      no: 35,
      title: '第一次公开的约会',
      date: '2026-09-12',
      preview:
        '两人第一次以情侣身份出现在同事聚会，陆屿却因为一条旧新闻被推上风口浪尖，夏知遥决定在节目里公开回应。',
    },
  },
  {
    id: 'wugang-mian',
    title: '雾港迷案',
    subtitle: '每一场雾里，都藏着一个人没说出口的证词',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20misty%20harbor%20at%20night%20in%20the%20rain%2C%20lone%20silhouette%20on%20a%20wet%20pier%2C%20warm%20amber%20street%20lamp%20glow%20cutting%20through%20fog%2C%20moody%20suspense%20thriller%20key%20art%2C%20muted%20teal%20shadows%20with%20warm%20highlights%2C%20mysterious%20atmosphere&width=600&height=800&seq=duanju-cover-04&orientation=portrait',
    category: '悬疑推理',
    tags: ['悬疑', '推理', '迷雾'],
    totalEpisodes: 36,
    updatedEpisodes: 27,
    status: '更新中',
    schedule: '每周三、周日 21:00 更新3集',
    scheduleDays: [3, 7],
    rating: 9.1,
    heat: 689000,
    synopsis:
      '雾港码头的一名夜班看守在凌晨失踪，三个月后他的手表出现在另一起纵火案的现场。刑警顾一舟与法医温言重新翻开卷宗，发现三起看似无关的旧案都指向同一年冬天的一场沉船事故。全季采用「一案一雾」的结构，每三集完结一条支线，同时把主线线索悄悄埋进每个路人的证词里，直到最后一场大雾散去，真相才真正浮出水面。',
    episodes: [
      {
        no: 22,
        title: '凌晨三点的失窃',
        summary:
          '码头仓库丢失的不是货物，而是一份二十年前的交接班记录。顾一舟在监控盲区捡到半枚被踩碎的纽扣。',
        date: '2026-09-06',
      },
      {
        no: 23,
        title: '法医的第二份报告',
        summary:
          '温言对旧案死者重新取样，发现当年结论与骨密度数据矛盾，她第一次怀疑起自己师父的鉴定意见。',
        date: '2026-09-06',
      },
      {
        no: 24,
        title: '雾里的出租车',
        summary:
          '一名出租车司机提供的行车记录仪录音里，出现了一个本不该出现在雾港的名字，案件开始向前回溯。',
        date: '2026-09-06',
      },
      {
        no: 25,
        title: '沉船名单上的一行涂改',
        summary:
          '顾一舟在档案馆找到当年沉船名单，发现有一个名字被人用同色墨水覆盖，涂改痕迹的力度暴露了写字人的习惯。',
        date: '2026-09-11',
      },
      {
        no: 26,
        title: '说谎的目击者',
        summary:
          '唯一目击者突然改口，温言从她手背的药膏发现她长期服用某种镇静剂，证词的可信度被彻底推翻。',
        date: '2026-09-11',
      },
      {
        no: 27,
        title: '灯灭的那三十秒',
        summary:
          '码头灯塔在案发时段短暂熄灭了三十秒。顾一舟调出电力记录，锁定了唯一能接近配电房的三个人。',
        date: '2026-09-11',
      },
    ],
    nextEpisode: {
      no: 28,
      title: '回港的旧船',
      date: '2026-09-13',
      preview:
        '那艘沉没二十年的旧货船被拖回港口，船舱里留下的不是货物，而是一整墙被钉住的老照片。',
    },
  },
  {
    id: 'zhanshen-guilai',
    title: '战神归来不低头',
    subtitle: '三年之后，他带着一身伤回到这座城',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20confident%20man%20in%20a%20sharp%20dark%20suit%20standing%20on%20a%20rooftop%20before%20a%20glowing%20city%20skyline%20at%20sunset%2C%20dramatic%20warm%20backlight%2C%20powerful%20urban%20action%20drama%20key%20art%2C%20deep%20amber%20and%20charcoal%20tones%2C%20heroic%20composition&width=600&height=800&seq=duanju-cover-05&orientation=portrait',
    category: '都市逆袭',
    tags: ['战神', '爽剧', '打脸'],
    totalEpisodes: 96,
    updatedEpisodes: 96,
    status: '已完结',
    schedule: '已完结 · 全集可看',
    scheduleDays: [],
    rating: 8.6,
    heat: 1567000,
    synopsis:
      '三年前被家族除名的沈砚，带着一身旧伤与一纸军工合作意向回到江城。他想做的只有一件事：把当年那场被伪造的工程事故查清楚。全季节奏干脆，前三十集以「回归—打脸—立威」三步走快速建立人物，中段揭开合作方内部的利益链，后段把私人恩怨放进更大的行业格局里解决。没有多余的煽情，只有一次又一次被低估之后的正面回击。',
    episodes: [
      {
        no: 1,
        title: '三年后的第一场雨',
        summary:
          '沈砚在江城机场落地，接机牌上写的却是别人的名字。他在雨里拦下一辆出租车，直接开去了当年出事的工地。',
        date: '2026-05-01',
      },
      {
        no: 2,
        title: '被换掉的签字',
        summary:
          '工程验收单上的签名并非出自他手。沈砚请来笔迹专家，发现替换签名的人就在当年的项目组里。',
        date: '2026-05-01',
      },
      {
        no: 3,
        title: '老部下的那顿饭',
        summary:
          '一位老部下请他吃饭，席间递来一份当年的值班表。沈砚第一次意识到，事故不是意外，而是一次有预谋的替换。',
        date: '2026-05-02',
      },
      {
        no: 4,
        title: '合作意向书上的空位',
        summary:
          '军工合作意向书上留着一个空位，正是三年前把他送走的那个部门。沈砚决定亲自把这个位置填上。',
        date: '2026-05-03',
      },
      {
        no: 5,
        title: '正面回击',
        summary:
          '在行业论坛上被公开质疑后，沈砚用一份完整的技术复盘当场拆穿对方的方案漏洞，全场安静了整整十秒。',
        date: '2026-05-04',
      },
      {
        no: 6,
        title: '不低头的理由',
        summary:
          '旧案迎来重审，沈砚在庭外拒绝了对方提出的和解。他抬头看天，说了一句：「我回来不是为了钱。」',
        date: '2026-05-05',
      },
    ],
    nextEpisode: null,
  },
  {
    id: 'jinxiu-yifei',
    title: '锦绣医妃',
    subtitle: '一双手救人，也掀得动一座深宅',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20elegant%20ancient%20Chinese%20noble%20lady%20in%20embroidered%20hanfu%20inside%20a%20candlelit%20herbal%20medicine%20room%2C%20shelves%20of%20herbs%20and%20porcelain%20jars%2C%20warm%20candlelight%20glow%2C%20refined%20period%20drama%20key%20art%2C%20jade%20green%20and%20gold%20tones&width=600&height=800&seq=duanju-cover-06&orientation=portrait',
    category: '古装剧场',
    tags: ['古装', '医女', '宅斗'],
    totalEpisodes: 72,
    updatedEpisodes: 51,
    status: '更新中',
    schedule: '每周一、周三、周五 19:30 更新2集',
    scheduleDays: [1, 3, 5],
    rating: 9.0,
    heat: 934000,
    synopsis:
      '医家独女裴锦绣嫁入侯府冲喜，本以为只是替母亲换一条活路，却在药方与脉案之间一步步看清这座宅子的病灶。她以「医者不自医，但可医人心」为信条，从后园的偏方查到前院的账目，把一桩桩看似偶然的病症串成一条完整的下毒链。全季以三次「开方」为节点：第一次治人，第二次治宅，第三次治的是整个侯府藏了二十年的秘密。',
    episodes: [
      {
        no: 46,
        title: '换了药引的补汤',
        summary:
          '裴锦绣尝出老夫人的补汤里换了一味药引，她不动声色地留下残渣，第一次在侯府拿到了实证。',
        date: '2026-09-07',
      },
      {
        no: 47,
        title: '偏方里的人名',
        summary:
          '一本后园流传的偏方册子里夹着半张脉案，落款人名已故多年，却与侯府账房的旧号完全对应。',
        date: '2026-09-07',
      },
      {
        no: 48,
        title: '脉案对不上的时辰',
        summary:
          '裴锦绣对比三份脉案，发现记载的发病时辰互相矛盾，有人刻意在掩盖真正下毒的时间点。',
        date: '2026-09-09',
      },
      {
        no: 49,
        title: '药柜最下层的锁',
        summary:
          '她在药柜最下层发现一把内锁，里面不是药材，而是二十年来的采买清单，每一笔都指向同一个人。',
        date: '2026-09-09',
      },
      {
        no: 50,
        title: '侯府的老仆',
        summary:
          '一位即将被逐出府的老仆主动找到她，交出当年经手的账册，条件是让她保住自己孙女的婚事。',
        date: '2026-09-11',
      },
      {
        no: 51,
        title: '第三次开方',
        summary:
          '裴锦绣当着全府的面开出第三张方子，方子上写满的不是药名，而是二十年前那桩旧事的全部证人。',
        date: '2026-09-11',
      },
    ],
    nextEpisode: {
      no: 52,
      title: '侯府的病根',
      date: '2026-09-14',
      preview:
        '第三张方子递出去后，侯府连夜换了门房。裴锦绣却发现，最该被问责的那个人，正安静地坐在老夫人床边。',
    },
  },
  {
    id: 'laoban-shi-mao',
    title: '我的老板是只猫',
    subtitle: '上班第一天，我发现顶头上司不太对劲',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20fluffy%20orange%20cat%20sitting%20on%20a%20modern%20office%20desk%20surrounded%20by%20paperwork%20and%20a%20laptop%2C%20cozy%20warm%20afternoon%20light%2C%20playful%20healing%20comedy%20key%20art%2C%20soft%20cream%20and%20amber%20tones%2C%20whimsical%20but%20elegant%20mood&width=600&height=800&seq=duanju-cover-07&orientation=portrait',
    category: '奇幻轻喜',
    tags: ['奇幻', '轻喜剧', '治愈'],
    totalEpisodes: 40,
    updatedEpisodes: 40,
    status: '已完结',
    schedule: '已完结 · 全集可看',
    scheduleDays: [],
    rating: 8.9,
    heat: 512000,
    synopsis:
      '刚入职的实习生程小满发现，公司那位传闻中极其严厉的总监陆屿川，每到下午三点就会短暂变回一只橘猫。为了不丢掉工作，也为了弄清楚这场「变身」的原因，她成了唯一知道秘密的人。全季用轻喜剧的节奏串起一间办公室的日常：加班、团建、竞争、和解，最后落在一个很温柔的答案上——真正让人卸下防备的，从来不是魔法，而是有人愿意陪着你。',
    episodes: [
      {
        no: 1,
        title: '入职第一天就撞见秘密',
        summary:
          '程小满抱着一摞文件推开总监办公室的门，看到椅背上蹲着一只橘猫，而总监的外套正整齐地搭在扶手。',
        date: '2026-06-20',
      },
      {
        no: 2,
        title: '下午三点的空椅子',
        summary:
          '每天三点，总监的座位都会空二十分钟。程小满一边替他打掩护，一边偷偷记下了每次变身的时间规律。',
        date: '2026-06-20',
      },
      {
        no: 3,
        title: '一份不该改的方案',
        summary:
          '为了护住团队的心血，程小满擅自改了一版方案。变身中的「老板」用爪子按住了那页纸，算是默许。',
        date: '2026-06-21',
      },
      {
        no: 4,
        title: '团建那天的雨',
        summary:
          '团建途中突降暴雨，程小满抱着装猫的纸箱冲进便利店，两个人第一次像同事，也第一次像朋友那样聊天。',
        date: '2026-06-22',
      },
      {
        no: 5,
        title: '变身的真正原因',
        summary:
          '程小满在老员工的旧照片里找到线索，原来这场变身与多年前一场未完成的承诺有关。',
        date: '2026-06-23',
      },
      {
        no: 6,
        title: '最后一个下午三点',
        summary:
          '陆屿川选择说出真相。那天下午三点，椅子没有再空，程小满却第一次觉得，办公室安静得有点不习惯。',
        date: '2026-06-24',
      },
    ],
    nextEpisode: null,
  },
  {
    id: 'shenzhai-bumianye',
    title: '深宅不眠夜',
    subtitle: '一个屋檐下，四代人没有说出口的话',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20quiet%20old%20family%20courtyard%20house%20at%20night%2C%20one%20lit%20window%2C%20a%20woman%20looking%20out%20thoughtfully%2C%20warm%20lamp%20glow%20against%20cool%20shadows%2C%20realistic%20family%20drama%20key%20art%2C%20restrained%20emotional%20atmosphere%2C%20cream%20and%20deep%20brown%20tones&width=600&height=800&seq=duanju-cover-08&orientation=portrait',
    category: '家庭情感',
    tags: ['家庭', '现实', '群像'],
    totalEpisodes: 54,
    updatedEpisodes: 22,
    status: '更新中',
    schedule: '每周五、周六 22:00 更新2集',
    scheduleDays: [5, 6],
    rating: 8.4,
    heat: 398000,
    synopsis:
      '一座住了四代人的老宅即将拆迁，长女周砚秋从外地回来处理房产，却在整理旧物的过程中重新拼起了这个家的记忆。剧本以「一间房、一顿饭、一次争吵」为单位推进，不制造极端冲突，只细细描摹普通家庭里那些被日常盖住的裂痕与牵挂。全季想讲的是：有些家庭不是不爱，只是所有人都习惯了不说。',
    episodes: [
      {
        no: 17,
        title: '搬空的第一间房',
        summary:
          '周砚秋开始整理父亲的书房，在一本旧相册里发现全家人唯一一张完整合影，背面写着日期和一句没头没尾的话。',
        date: '2026-09-04',
      },
      {
        no: 18,
        title: '兄弟之间的一次沉默',
        summary:
          '关于老宅的补偿款，两兄弟第一次坐在同一张桌前。话没说几句，母亲端上的一碗汤让争吵停在了半空。',
        date: '2026-09-04',
      },
      {
        no: 19,
        title: '母亲的旧账本',
        summary:
          '母亲有一个记了三十年的账本，上面每一笔「支出」都对应着一个家人的名字，包括早已离家的女儿。',
        date: '2026-09-11',
      },
      {
        no: 20,
        title: '年夜饭的座位',
        summary:
          '为了一次提前的团圆饭，周砚秋试着把每个人的座位重新排了一遍，却发现最难摆平的是各自的沉默。',
        date: '2026-09-11',
      },
      {
        no: 21,
        title: '屋顶漏下的雨',
        summary:
          '一场夜雨漏进老宅，全家一起上屋顶修补。在狭小的屋顶上，有些话终于找到了说出口的机会。',
        date: '2026-09-12',
      },
      {
        no: 22,
        title: '不眠的那一夜',
        summary:
          '拆迁通知正式下来。那一夜没有人睡着，周砚秋却在厨房的灯下，第一次听见母亲讲起自己的年轻时候。',
        date: '2026-09-12',
      },
    ],
    nextEpisode: {
      no: 23,
      title: '最后一顿家常饭',
      date: '2026-09-18',
      preview:
        '老宅交房前的最后一晚，母亲坚持要做一桌家常菜，而周砚秋在储物间里翻出了一个谁也不愿提起的盒子。',
    },
  },
];